import { createContext, ReactNode, useContext } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import { UseWebSocketReturn } from '../types/websocket';

interface WebSocketContextType extends UseWebSocketReturn {}

const WebSocketContext = createContext<WebSocketContextType | null>(null);

interface WebSocketProviderProps {
  children: ReactNode;
}

export function WebSocketProvider({ children }: WebSocketProviderProps) {
  const webSocket = useWebSocket({
    autoConnect: true,
    reconnectInterval: 3000,
    maxReconnectAttempts: 5,
    heartbeatInterval: 30000,
  });

  return (
    <WebSocketContext.Provider value={webSocket}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWebSocketContext(): WebSocketContextType {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error(
      'useWebSocketContext must be used within a WebSocketProvider',
    );
  }
  return context;
}

// Convenience hook for sending messages
export function useWebSocketConnect() {
  const { sendMessage, isConnected, connectionState, lastError } =
    useWebSocketContext();

  return {
    sendMessage,
    isConnected,
    connectionState,
    lastError,
  };
}
